module.exports = __webpack_public_path__ + "img/img_tokenomic.12d47ebe.png";